module.exports = __webpack_public_path__ + "static/girallon-52fd7e541d2cd9907a5313600648b02a.jpeg";